// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/report/stock/Report.css
// module id = 2024
// module chunks = 0